<div class="dialog">
    <div class="header">
        <img src="assets/svg/Sucess.svg" alt="">
        <h6 class=" mt-2">Confirm To Accept this Purchase Order</h6>
        <h6 class="terms">Terms and Conditions :</h6>
    </div>
    <div class="content mt-3">
        <p *ngFor=" let term of finalTnc">
            {{term?.description}}
        </p>
    </div>
    <div class="footer mt-3 row">
        <button (click)="accept()" class="mr-2 orange">Yes</button>
        <button (click)="close()" class="ml-2 white">No</button>
    </div>

</div>